// APP WIDE
export const DESKTOP_BREAKPOINT = 'md'
export const CONTENT_PADDING_RBL_REM = '0.5rem'
export const CONTENT_PADDING_T_REM = '0.25rem'
export const CONTENT_PADDING_REM = `${CONTENT_PADDING_T_REM} ${CONTENT_PADDING_RBL_REM} ${CONTENT_PADDING_RBL_REM} ${CONTENT_PADDING_RBL_REM}`
export const CHROME_SCROLLBAR_HEIGHT = 15

// APPBAR
export const APPBAR_HEIGHT_REM = '4rem'
export const APPBAR_EXTRA_DESKTOP_REM = '0.5rem'

// SIDEBAR
export const DESKTOP_DRAWER_WIDTH = 200
export const COLLAPSED_DESKTOP_DRAWER_WIDTH = 56
export const MOBILE_DRAWER_WIDTH = 300
export const COLLAPSE_SIDEBAR_ICON_BOTTOM_PADDING_REM = '1.5rem'

// DASHBOARD
export const DASHBOARD_TITLE_HEIGHT_REM = '2rem'
export const DASHBOARD_GRID_SPACING_REM = '0.5rem'

// FARM SELECTOR
export const SELECTOR_WIDTH_VW = '15rem'
export const SELECTOR_MIN_WIDTH_PX = 250

// PREFERNCES / ACCOUNT
export const PAGE_TOC_WIDTH = '150px'

// COMPUTED
export const FULLSCREEN_HEIGHT_MD = `calc(\
  100vh\
  - ${APPBAR_HEIGHT_REM}\
  - ${APPBAR_EXTRA_DESKTOP_REM}\
  - ${CONTENT_PADDING_T_REM}\
)`
